import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastMessageOptions } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Toast, ToastModule as PToastModule } from 'primeng/toast';
import { IconByTypePipe } from './icon-by-type.pipe';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    PToastModule,
    RouterModule,
    ButtonModule,
    AngularSvgIconModule,
    IconByTypePipe,
  ],
})
export class ToastComponent {
  constructor(readonly toastService: ToastService) {}

  onClose(
    { target }: { target: HTMLButtonElement },
    toast: Toast,
    message: ToastMessageOptions
  ): void {
    const index = +target
      .closest('p-toastitem')
      .getAttribute('ng-reflect-index');

    toast.onMessageClose({
      index,
      message,
    });
  }
}
